<template>
    <div class="background-image w-100 position-absolute top-0 z-0"></div>
</template>
<style scoped>
.background-image {
    /* background: black !important; */
    background: linear-gradient(to bottom, rgba(0,0,0,0.6), rgba(0,0,0,0.6), rgba(0,0,0,1));
    height: 100vh;
}
</style>